import * as React from "react";
import { FileUploadDataErrors } from "../../TypeScript/interfaces";

interface Props {
    country: string;
    errors: FileUploadDataErrors;
  }
const FileUploadTexts: React.FC<Props> = (props) => {
    const {country, errors} = props;


  return (
    <div>
      {country === "Italy" && (
        <p>
          This facility allows you to complement your 'One-Time Certificate for
          Italian Equities' to be able to benefit from a reduced rate in
          accordance with the double taxation treaty in place with Italy.
        </p>
      )}

      {country === "South Korea" && (
        <p>
          This facility allows you to provide us with the details of your
          beneficial owners as required by the South Korean tax authorities for
          the South Korean depository receipts you are holding with Clearstream.
        </p>
      )}

      {country === "Singapore" && (
        <p>
          This facility allows you to provide us with the details of the
          Beneficial Owners on behalf of whom you hold Singapore REITs to be
          able to benefit from reduce withholding tax rate.
        </p>
      )}

      {errors.validSetup === false && (
        <p style={{ color: "red" }}>
          Some errors have been detected and are highlighted below. Mandatory
          fields are marked with an asterisk (*).
        </p>
      )}
    </div>
  );
};

export default FileUploadTexts;